import serviceJava from "@/lib/requestJava";
import { formatQuery } from "@/utils/paramFormat";

export default {
  /** 检查站点是否上线 */
  handlerCheckUnionIsOnline: (params) =>
    serviceJava.get(
      `/ess-union-api/lm-union-info/do/get-use-new-site${formatQuery(params)}`,
      {},
      {
        headers: {
          isSuccess: true
        }
      }
    ), // 获取考试时间和倒计时
  // 查询广告banner
  handlerGetAdvBanner: (params) => serviceJava.get(`/ess-ecms-api/advert/do/advlist${formatQuery(params)}`),

  // 查询机构后台配置的图
  getLmSiteBanner: (params) => serviceJava.get(`/ess-bms-api/lmmemberssite/do/get-single-site-info${formatQuery(params)}`),

  // 通过dcourseId 查询播放渠道信息
  getPlayChannelByDcourseId: (params) => serviceJava.get(`/ess-bms-api/vod-play/do/by-net-detailids${formatQuery(params)}`),

  // 学员端获取机构权限和客服信息
  getUnionInfo: (params) => serviceJava.get(`/ess-union-api/lm-union-info/do/get-union-info${formatQuery(params)}`)
};
